var map = {
	"./allow-privilege-escalation-psp.json": "c250",
	"./allowed-fsgroups-psp.json": "cd09",
	"./allowed-proc-mount-types-psp.json": "3337",
	"./apparmor-psp.json": "1517",
	"./capabilities-psp.json": "5249",
	"./flexvolume-drivers-psp.json": "6d86",
	"./host-namespaces-psp.json": "ba38",
	"./hostpaths-psp.json": "4234",
	"./ingress.json": "6038",
	"./pod-runtime.json": "679c",
	"./safe-annotations.json": "040c",
	"./safe-labels.json": "37ac",
	"./seccomp-psp.json": "8a41",
	"./selinux-psp.json": "bad1",
	"./sysctl-psp.json": "3fdc",
	"./trusted-repos.json": "8ea3",
	"./user-group-psp.json": "c3e9",
	"./verify-image-signatures.json": "d047",
	"./volumes-psp.json": "a5f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2275";